module.exports = __webpack_public_path__ + "img/main2.64570fd4.png";